export default __webpack_public_path__ + "static/media/organic_growth.d3fb5a05.png";